// Manages recent customer search terms in localStorage
// Stores up to 30 searches, displays max 5

const STORAGE_KEY = 'customer_recent_searches'
const MAX_STORED = 30
const MAX_DISPLAY = 5

export class RecentSearchesManager {
  static load() {
    try {
      const stored = localStorage.getItem(STORAGE_KEY)
      return stored ? JSON.parse(stored) : []
    } catch (e) {
      console.error('Failed to load recent searches:', e)
      return []
    }
  }

  static save(searches) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(searches))
    } catch (e) {
      console.error('Failed to save recent searches:', e)
    }
  }

  static add(searchTerm) {
    if (!searchTerm || searchTerm.trim() === '') return

    const searches = this.load()
    const trimmed = searchTerm.trim()

    // Remove if already exists (to move it to the front)
    const filtered = searches.filter(s => s.toLowerCase() !== trimmed.toLowerCase())

    // Add at the beginning and limit to MAX_STORED
    const updated = [trimmed, ...filtered].slice(0, MAX_STORED)
    this.save(updated)

    return updated
  }

  static getRecent(count = MAX_DISPLAY) {
    return this.load().slice(0, count)
  }

  static search(query) {
    if (!query || query.trim() === '') {
      return this.getRecent()
    }

    const searches = this.load()
    const lowerQuery = query.toLowerCase()

    return searches
      .filter(s => s.toLowerCase().includes(lowerQuery))
      .slice(0, MAX_DISPLAY)
  }

  static clear() {
    this.save([])
  }
}
